<template>
  <div>
    <el-form ref="formRef" :model="formData" :rules="rules" label-position="top">
      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="公益事务代表：" prop="resident_agent">
            <el-input
              :controls="false"
              style="width:85%"
              size="small"
              v-model="formData.resident_agent"
              placeholder="请填写公益事务代表"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="项目对接人：" prop="group_leader">
            <el-input
              :controls="false"
              style="width:85%"
              size="small"
              v-model="formData.group_leader"
              placeholder="请填写项目对接人"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center" v-if="$route.query.type == 1">
        <el-col :span="10">
          <el-form-item label="负责人职务：" prop="duties">
            <el-input
              :controls="false"
              style="width:85%"
              size="small"
              v-model="formData.duties"
              placeholder="请填写负责人职务"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="负责人联系方式：" prop="contact">
            <el-input
              :controls="false"
              style="width:85%"
              size="small"
              v-model="formData.contact"
              placeholder="请填写负责人联系方式"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item label="医保局备案：" prop="if_medival_report">
            <el-radio-group v-model="formData.if_medival_report" size="small">
              <el-radio :label="1" border>是</el-radio>
              <el-radio :label="2" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="卫计委备案：" prop="if_hygiene_report">
            <el-radio-group v-model="formData.if_hygiene_report" size="small">
              <el-radio :label="1" border>是</el-radio>
              <el-radio :label="2" border>否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item
            label="医保局备案信息："
            prop="medival_report_info"
            v-if="formData.if_medival_report == 1"
          >
            <el-input
              v-model="formData.medival_report_info"
              style="width:85%"
              type="textarea"
              :maxlength="200"
              :rows="3"
              placeholder="请输入医保局备案信息"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="备案计划："
            prop="medival_report_plan"
            v-if="formData.if_medival_report == 2"
          >
            <el-input
              v-model="formData.medival_report_plan"
              style="width:85%"
              type="textarea"
              :maxlength="200"
              :rows="3"
              placeholder="请输入医保局备案计划"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item
            label="卫计委备案信息："
            prop="hygiene_report_info"
            v-if="formData.if_hygiene_report == 1"
          >
            <el-input
              v-model="formData.hygiene_report_info"
              style="width:85%"
              type="textarea"
              :maxlength="200"
              :rows="3"
              placeholder="请输入卫计委备案信息"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="卫计委备案计划："
            prop="hygiene_report_plan"
            v-if="formData.if_hygiene_report == 2"
          >
            <el-input
              v-model="formData.hygiene_report_plan"
              style="width:85%"
              type="textarea"
              :maxlength="200"
              :rows="3"
              placeholder="请输入卫计委备案计划"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center" v-if="$route.query.type === 1">
        <el-col :span="20">
          <el-form-item label="项目执行团队信息：" required>
            <el-table border :data="formData.project_team">
              <el-table-column prop="cost_item" label="分工">
                <template slot-scope="scope">
                  <el-select
                    v-model="formData.project_team[scope.$index].type"
                    size="small"
                    placeholder="请选择分工"
                    :clearable="true"
                    @change="selChange($event,scope.$index)"
                  >
                    <el-option
                      v-for="item in personType"
                      :key="item.value"
                      :label="item.text"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="user_name" label="姓名">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="formData.project_team[scope.$index].user_name"
                    placeholder="姓名"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="duties" label="职务">
                <template slot-scope="scope">
                  <el-input
                    size="small"
                    v-model="formData.project_team[scope.$index].duties"
                    placeholder="职务"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column width="100" align="center">
                <template slot="header" slot-scope="scope">
                  <el-button type="primary" size="small" @click="addPersonGroup">新增</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button type="danger" size="small" @click="delPersonGroup(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row type="flex" justify="center">
        <el-col :span="10">
          <el-form-item
            :label="item.file_type_name"
            v-for="(item,index) in upload_list"
            :key="index"
            :required="item.if_must===1"
          >
            <el-upload
              v-if="item.file_type == 1"
              :ref="'uploadRef'+index"
              :action="uploadFileUrl"
              multiple
              :file-list="defFileArr[index]"
              :before-upload="beforeUploadFile"
              :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,index,'defFileArr');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,index,'defFileArr');
                    }"
              style="width:80%"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
            <el-upload
              v-if="item.file_type == 2"
              :action="uploadImgUrl"
              list-type="picture-card"
              :ref="'uploadRef'+index"
              :on-preview="showImg"
              :file-list="defFileArr[index]"
              :data="{ file_type: 2 }"
              name="img"
              multiple
              :before-upload="beforeUploadImg"
              :on-success="(response, file, fileList) =>{
                      handlerUpload(fileList,index,'defFileArr');
                    }"
              :on-remove="(file, fileList) =>{
                      handlerUpload(fileList,index,'defFileArr');
                    }"
                    
            >
              <i class="el-icon-plus"></i>
              <div class="el-upload__tip" slot="tip">只能上传jpg、jpeg、png 格式50M以内的图片</div>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="10"></el-col>
      </el-row>

      <el-dialog :visible.sync="img_show" append-to-body>
        <img width="100%" :src="img_url" alt />
      </el-dialog>
    </el-form>
  </div>
</template>
<script>
import baseUrl from "@/config/index";
export default {
  props: {
    // 项目id
    id: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    var personGroup = (rule, value, callback) => {
      if (typeof this.formData.project_team === "undefined") {
        return callback(new Error("请填写项目执行团队信息！"));
      } else {
        if (this.formData.project_team.length === 0) {
          return callback(new Error("请填写项目执行团队信息！"));
        } else {
          this.formData.project_team.forEach((item, index) => {
            let num = index + 1;
            if (!item.type) {
              return callback(
                new Error("请选择" + num + "条项目执行团队信息分工")
              );
            } else if (!item.user_name) {
              return callback(
                new Error("请完善第" + num + "条项目执行团队信息姓名")
              );
            } else if (!item.duties) {
              return callback(
                new Error("第完善第" + num + "条项目执行团队信息职位")
              );
            }
          });
        }
      }
      return callback();
    };

    var checkPhone = (rule, value, callback) => {
      if (this.formData.contact) {
        let mobile = /^[1][0-9]{10}$/;
        if (!mobile.test(this.formData.contact)) {
          return callback(new Error("手机号格式不正确！"));
        }
      }
      return callback();
    };

    return {
      readmeFile: [], //必读文件
      downProjectFile: false, //判断是否下载立项必读文件
      dialogVisible: true, //立项协议
      upload_list: [], //获取需要上传的文件列表

      uploadFileUrl: "", //文件上传地址
      uploadImgUrl: "", //图片上传地址
      img_url: "",
      img_show: false,
      defFileArr: [], //图片编辑数组
      personType: [], //人员类别
      formData: {
        resident_agent: null,
        group_leader: JSON.parse(sessionStorage.getItem("unitAuth")).user_name,
        if_medival_report: 1,
        medival_report_info: null,
        medival_report_plan: null,
        if_hygiene_report: 1,
        hygiene_report_info: null,
        hygiene_report_plan: null,
        approval_files: [],
        project_team: [],
        duties: null,
        contact: null
      }, //表单数据
      rules: {
        resident_agent: [
          { required: true, message: "请填写公益事务代表！", trigger: "blur" }
        ],
        group_leader: [
          { required: true, message: "请输入项目对接人！", trigger: "blur" }
        ],
        duties: [
          { required: true, message: "请输入项目负责人职务！", trigger: "blur" }
        ],
        contact: [
          {
            required: true,
            message: "请输入项目负责人联系方式！",
            trigger: "blur"
          },
          { validator: checkPhone, trigger: "blur" }
        ],
        medival_report_info: [
          { required: true, message: "请输入医保局报备信息！", trigger: "blur" }
        ],
        medival_report_plan: [
          { required: true, message: "请输入医保局报备计划！", trigger: "blur" }
        ],
        hygiene_report_info: [
          { required: true, message: "请输入卫计委报备信息！", trigger: "blur" }
        ],
        hygiene_report_plan: [
          { required: true, message: "请输入卫计委报备计划！", trigger: "blur" }
        ],
        project_team: [
          {
            required: true,
            message: "请添加项目执行团队信息！",
            trigger: "change",
            type: "array"
          },
          { validator: personGroup, trigger: "change" }
        ]
      } //验证规则
    };
  },
  methods: {
    //预览图片
    showImg(file) {
      if (file.response) {
        this.img_url = file.response.data.url;
      } else {
        this.img_url = file.url;
      }
      this.img_show = true;
    },

    handlerUpload(fileList, index,name) {
      this.$set(this[name],index, []);
      this.$set(this[name],index, fileList);
    },

    beforeUploadImg(file) {
      let bool = this.$fnc.checkUploadImg(file);
      return bool;
    },

    //获取编辑数据
    getEditInfo() {
      this.$db
        .post(this.$db.config.com_project.approval.detail, {
          id: this.$route.query.id
        })
        .then(res => {
          if (res.code == 200) {
            this.formData = res.data;
            res.data.approval_files.forEach((item, index) => {
              this.$set(this.defFileArr, index, item.file_path);
            });

            if (!res.data.if_medival_report) {
              this.formData.if_medival_report = 1;
            }

            if (!res.data.if_hygiene_report) {
              this.formData.if_hygiene_report = 1;
            }

            if (!res.data.project_team) {
              this.formData.project_team = [];
            }
          }
        });
    },

    //添加团队信息
    addPersonGroup() {
      let pushArr = {
        type: null,
        user_name: null,
        duties: null
      };
      let len = this.formData.project_team.length;

      if (len && len > 0) {
        if (
          !this.formData.project_team[len - 1].type ||
          !this.formData.project_team[len - 1].user_name ||
          !this.formData.project_team[len - 1].duties
        ) {
          return this.$message.warning("请先完善上一行信息，再执行该操作！");
        }
      }

      this.formData.project_team.push(pushArr);
    },

    //救助团队信息
    delPersonGroup(index) {
      this.formData.project_team.splice(index, 1);
    },

    //表单验证
    checkForm() {
      let that = this;
      let bool = false;
      that.$refs["formRef"].validate(valid => {
        if (valid) {
          //处理遍历的附件图片
          for (const [key, val] of that.upload_list.entries()) {
            let cur = that.defFileArr[key];
            let arr = [];
            if (cur && cur.length > 0) {
              for (const item of cur) {
                if (item.hasOwnProperty("response")) {
                  arr.push(item.response.data.id);
                } else {
                  arr.push(item.id);
                }
              }
              val.file_ids = arr;
            } else {
              if (val.if_must === 1) {
                that.$message.warning(val.file_type_name + "不能为空！");
                bool = false;
                return false;
              }
            }
          }
          that.formData.approval_files = that.upload_list;
          bool = true;
        } else {
          that.$message({
            type: "warning",
            message: "请填写完整表单信息！"
          });
          bool = false;
        }
      });
      if (
        !(
          this.formData.project_team && this.formData.project_team.length > 0
        ) &&
        this.$route.query.type == 1
      ) {
        bool = false;
        that.$message.warning("请添加项目执行团队信息！");
      }
      return bool;
    },

    selChange(val, index) {
      let text = this.personType.find(item => item.value === val).text;
      this.formData.project_team[index].type_text = text;
    },

    //提交表单操作
    submitF() {
      let that = this;

      let ifpass = this.checkForm();
      if (ifpass) {
        that.$db.post(that.$db.config.approvalSave, that.formData).then(res => {
          //先保存数据
          if (res && res.code == 200) {
            //提交操作
            that.$db
              .post(that.$db.config.publicBuildSubmit, { id: that.id })
              .then(res => {
                if (res.code == 200) {
                  that.$message({
                    type: "success",
                    message: res.msg,
                    duration: 1000,
                    onClose: () => {
                      that.$router.push({ name: "hospitalBuildList" });
                    }
                  });
                }
              });
          }
        });
      }
    },

    // 保存操作
    onSave(data = {}) {
      let that = this;
      let ifpass = this.checkForm();
      if (ifpass) {
        that.$db.post(that.$db.config.approvalSave, that.formData).then(res => {
          if (res && res.code == 200) {
            that.$message({
              type: "success",
              message: res.msg,
              duration: 1000,
              onClose: () => {
                that.$router.push({ name: "hospitalBuildList" });
              }
            });
          }
        });
      }
    },

    //文件上传前操作
    beforeUploadFile(file) {
      let bool = this.$fnc.checkUploadFile(file);
      return bool;
    },

    //获取上传文件列表
    getUploadList() {
      this.$db
        .post(this.$db.config.com_project.approval.upload_list, {
          project_before_type: this.$route.query.type
        })
        .then(res => {
          this.upload_list = res.data.approval_files;
        });
    }
  },
  mounted() {
    if (this.$route.query.id > 0) {
      this.getEditInfo();
    }

    this.getUploadList();

    this.uploadFileUrl = baseUrl + this.$db.config.uploadFileUrl;
    this.uploadImgUrl = baseUrl + this.$db.config.uploadImgUrl;
    this.formData.id = this.id;

    //人员类别
    this.$db
      .post(this.$db.config.getDictParam, {
        pid: 100300,
        table: "pub_type_param"
      })
      .then(res => {
        if (res.code == 200) {
          this.personType = res.data;
        }
      });

    // //项目必读文件
    // this.$db.post(this.$db.config.publicBuildApprovalReadFile, {}).then(res => {
    //   if (res.code == 200) {
    //     this.readmeFile = res.data;
    //   }
    // });
  }
};
</script>

<style scoped>
.table {
  width: calc(100% - 100px);
  margin: 20px 50px;
}
.table td {
  width: 50%;
  max-width: 50%;
  border-bottom: 1px dashed #eee;
}
</style>




// WEBPACK FOOTER //
// src/components/Hospital/comproject/approval/step/second.vue